/**
 * Runs checkAuth on app mount - replaces AuthContext's initial auth check
 */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { checkAuth } from '../store/slices/authSlice';
import OneSignalRegister from './OneSignalRegister';

const AuthInit = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

  return (
    <>
      <OneSignalRegister />
      {children}
    </>
  );
};

export default AuthInit;
